import React, { useEffect, useState } from 'react';
import { Box, styled, Typography, Skeleton, useMediaQuery, useTheme } from '@mui/material';
import Slider from 'react-slick';
import { getStories } from '../asiosConfig';
import { toast } from 'react-toastify';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { StoryBox } from './StoryBox';

const StoryWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 0),
  '.slick-track': {
    display: 'flex',
  },
}));

const SkeletonStoryBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: 'center',
}));

function Story() {
  const [story, setStory] = useState([]);
  const [loading, setLoading] = useState(true);
  const theme = useTheme();

  // Media Queries
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); // <600px
  const isMediumScreen = useMediaQuery(theme.breakpoints.between('sm', 'md')); // 600px - 960px
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md')); // >960px

  useEffect(() => {
    const fetchStories = async () => {
      try {
        const response = await getStories();
        if (response.status === 200 || response.status === 201) {
          setStory(response.data.data || []);
        } else {
          toast.error('Failed to fetch stories');
        }
      } catch (error) {
        toast.error(error.response?.data?.message || 'An error occurred');
      } finally {
        setLoading(false);
      }
    };
    fetchStories();
  }, []);

  // Dynamically adjust slidesToShow but ensure it never exceeds story.length
  let slidesToShow = isSmallScreen ? 1 : isMediumScreen ? 2 : 3;
  slidesToShow = Math.min(slidesToShow, story.length); // Avoid showing extra slides

  const settings = {
    dots: true,
    infinite: false, // Prevent repeating slides
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
  };

  return (
    <StoryWrapper>
      <div className="story">
        <div className="container">
          <div className="storyTitle text-center">
            <h3>IND Matrimony Success Story</h3>
          </div>

          <div className="row justify-content-center align-items-center mt-4">
            {loading ? (
              <Slider {...settings}>
                {Array.from({ length: slidesToShow }).map((_, index) => (
                  <SkeletonStoryBox key={index}>
                    <Skeleton variant="rectangular" width="100%" height={150} />
                    <Skeleton variant="text" width="60%" sx={{ mt: 1 }} />
                    <Skeleton variant="text" width="80%" />
                  </SkeletonStoryBox>
                ))}
              </Slider>
            ) : story.length === 0 ? (
              <Typography variant="h6" align="center">
                No Story Found
              </Typography>
            ) : (
              <Slider {...settings}>
                {story.map((item, index) => (
                  <StoryBox
                    key={index}
                    image={item.images}
                    bride={item.bride}
                    groom={item.groom}
                    story={item.story}
                    date={item.marriage_date}
                  />
                ))}
              </Slider>
            )}
          </div>
        </div>
      </div>
    </StoryWrapper>
  );
}

export default Story;
